import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { fetchAdminUsers } from '../../actions';
import { getAdminUsers, getPagination } from '../../selectors';

const mapStateToProps = state => ({
  adminUsers: getAdminUsers(state),
  showLoading: state.admin.isFetching,
  pagination: getPagination(state),
});

const mapDispatchToProps = {
  fetchAdminUsers,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.fetchAdminUsers();
    },
  }),
  withState('page', 'setPage', 1),
  withHandlers({
    onPageChange: props => (page) => {
      window.scrollTo(0, 0);
      props.setPage(page);
      props.fetchAdminUsers(page);
    },
  }),
);
